import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DynamicBreadcrumbs from '../dynamic_breadcumb/dynamic_breadcrumb';
import './vendors.css';
import { Col, Container, Row, Alert } from 'react-bootstrap';
import axiosInstance from '../../API/axiosInstance';
import VendorCard from '../../ui_components/vendor_card/vendor_card';

export default function DisplayVendor() {
    const { category } = useParams();
    const [vendors, setVendors] = useState([]);
    const [wishlistIds, setWishlistIds] = useState(new Set());
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });

    const capitalizeFirstLetter = (str) => {
        if (typeof str !== 'string' || str.length === 0) {
            return '';
        }
        return (str.charAt(0).toUpperCase() + str.slice(1)).replace(" ","-");
    };

    useEffect(() => {
        const loadData = async () => {
            const token = localStorage.getItem('token');
            const storedUser = localStorage.getItem('currentUser');
            const user = storedUser ? JSON.parse(storedUser) : null;

            try {
                const formattedCategory = category.replaceAll('-', ' ');
                const vendorsUrl = `/vendor/verified/by-category/${formattedCategory}`;

                const vendorPromise = axiosInstance.get(vendorsUrl);
                const wishlistPromise = user ? axiosInstance.get(`/wishlist/${user.id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }) : Promise.resolve({ data: [] });


                const [vendorResponse, wishlistResponse] = await Promise.all([vendorPromise, wishlistPromise]);

                if (vendorResponse.status === 200) {
                    setVendors(vendorResponse.data);
                }

                setWishlistIds(new Set(wishlistResponse.data));

            } catch (error) {
                console.error("Failed to load data:", error);
            }
        };

        loadData();
    }, [category]);

    const handleWishlistToggle = async (vendor) => {
        const token = localStorage.getItem('token');
        const storedUser = localStorage.getItem('currentUser');

        if (!token || !storedUser) {
            setNotification({ show: true, message: 'Please log in to manage your wishlist.', type: 'danger' });
            setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
            return;
        }

        const user = JSON.parse(storedUser);
        const newWishlistIds = new Set(wishlistIds);
        let message = '';

        try {
            if (wishlistIds.has(vendor.id)) {
                // --- REMOVE from wishlist ---
                const endpoint = `/wishlist/${user.id}/remove?vendorId=${vendor.id}`;
                await axiosInstance.delete(endpoint, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                newWishlistIds.delete(vendor.id);
                message = `${vendor.business_name} removed from wishlist.`;
                setNotification({ show: true, message, type: 'warning' });
            } else {
                // --- ADD to wishlist ---
                const endpoint = `/wishlist/${user.id}/add?vendorId=${vendor.id}`;
                await axiosInstance.post(endpoint, null, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                newWishlistIds.add(vendor.id);
                message = `${vendor.business_name} added to wishlist!`;
                setNotification({ show: true, message, type: 'success' });
            }
            // Update the local state immediately for instant UI feedback
            setWishlistIds(newWishlistIds);
        } catch (err) {
            console.error("Wishlist API Error:", err);
            setNotification({ show: true, message: 'Failed to update wishlist.', type: 'danger' });
        } finally {
            setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
        }
    };

    return (
        <Container className="py-2">
            <DynamicBreadcrumbs />
            {notification.show && (
                <Alert
                    variant={notification.type}
                    onClose={() => setNotification({ show: false, message: '', type: '' })}
                    dismissible
                    className="my-3"
                >
                    {notification.message}
                </Alert>
            )}

            <h2 className="mb-0" id='category-title'>{capitalizeFirstLetter(category)}</h2>

            {vendors.length != 0 ?
                <>
                    <Row xs={1} sm={2} lg={3} className="g-4 mt-2">
                        {vendors.map((vendor) => (
                            <Col key={vendor.id}>
                                <VendorCard
                                    vendor={vendor}
                                    isInWishlist={wishlistIds.has(vendor.id)}
                                    onWishlistToggle={handleWishlistToggle}
                                />
                            </Col>
                        ))}
                    </Row>

                </> : <>
                    <h4 className='text-center mt-5'>No Vendors found in {category}</h4>
                </>}
        </Container>
    );
}